/**
 * Dark theme color palette
 * Raw color definitions with 0-100 scale for each color
 */

const darkColorPalette = {
  // Primary colors
  blue: {
    0: '#0c1a2e',
    10: '#1e3a8a',
    20: '#1e40af',
    30: '#1d4ed8',
    40: '#2563eb',
    50: '#3b82f6',
    60: '#60a5fa',
    70: '#93c5fd',
    80: '#bfdbfe',
    90: '#dbeafe',
    100: '#eff6ff',
  },

  // Secondary colors
  green: {
    0: '#052e16',
    10: '#14532d',
    20: '#166534',
    30: '#15803d',
    40: '#16a34a',
    50: '#22c55e',
    60: '#4ade80',
    70: '#86efac',
    80: '#bbf7d0',
    90: '#dcfce7',
    100: '#f0fdf4',
  },

  // Neutral colors
  gray: {
    0: '#030712',
    10: '#111827',
    20: '#1f2937',
    30: '#374151',
    40: '#4b5563',
    50: '#6b7280',
    60: '#9ca3af',
    70: '#d1d5db',
    80: '#e5e7eb',
    90: '#f3f4f6',
    100: '#f9fafb',
  },

  // Accent colors
  red: {
    0: '#450a0a',
    10: '#7f1d1d',
    20: '#991b1b',
    30: '#b91c1c',
    40: '#dc2626',
    50: '#ef4444',
    60: '#f87171',
    70: '#fca5a5',
    80: '#fecaca',
    90: '#fee2e2',
    100: '#fef2f2',
  },

  yellow: {
    0: '#3d3200',
    10: '#5c4b00',
    20: '#7a6400',
    30: '#997d00',
    40: '#b89600',
    50: '#d4af00',
    60: '#f0c800',
    70: '#ffe033',
    80: '#ffeb66',
    90: '#fff4a3',
    100: '#fffbe6',
  },

  purple: {
    0: '#3b0764',
    10: '#581c87',
    20: '#6b21a8',
    30: '#7c3aed',
    40: '#9333ea',
    50: '#a855f7',
    60: '#c084fc',
    70: '#d8b4fe',
    80: '#e9d5ff',
    90: '#f3e8ff',
    100: '#faf5ff',
  },

  pink: {
    0: '#500724',
    10: '#831843',
    20: '#9d174d',
    30: '#be185d',
    40: '#db2777',
    50: '#ec4899',
    60: '#f472b6',
    70: '#f9a8d4',
    80: '#fbcfe8',
    90: '#fce7f3',
    100: '#fdf2f8',
  },

  indigo: {
    0: '#1e1b4b',
    10: '#312e81',
    20: '#3730a3',
    30: '#4338ca',
    40: '#4f46e5',
    50: '#6366f1',
    60: '#818cf8',
    70: '#a5b4fc',
    80: '#c7d2fe',
    90: '#e0e7ff',
    100: '#eef2ff',
  },

  teal: {
    0: '#042f2e',
    10: '#134e4a',
    20: '#115e59',
    30: '#0f766e',
    40: '#0d9488',
    50: '#14b8a6',
    60: '#2dd4bf',
    70: '#5eead4',
    80: '#99f6e4',
    90: '#ccfbf1',
    100: '#f0fdfa',
  },

  orange: {
    0: '#7c2d12',
    10: '#9a3412',
    20: '#c2410c',
    30: '#dc2626',
    40: '#ea580c',
    50: '#f97316',
    60: '#fb923c',
    70: '#fdba74',
    80: '#fed7aa',
    90: '#ffedd5',
    100: '#fff7ed',
  },

  // Semantic colors (aliases)
  primary: {
    0: '#0c1a2e',
    10: '#1e3a8a',
    20: '#1e40af',
    30: '#1d4ed8',
    40: '#2563eb',
    50: '#3b82f6',
    60: '#60a5fa',
    70: '#93c5fd',
    80: '#bfdbfe',
    90: '#dbeafe',
    100: '#eff6ff',
  },

  secondary: {
    0: '#052e16',
    10: '#14532d',
    20: '#166534',
    30: '#15803d',
    40: '#16a34a',
    50: '#22c55e',
    60: '#4ade80',
    70: '#86efac',
    80: '#bbf7d0',
    90: '#dcfce7',
    100: '#f0fdf4',
  },

  success: {
    0: '#052e16',
    10: '#14532d',
    20: '#166534',
    30: '#15803d',
    40: '#16a34a',
    50: '#22c55e',
    60: '#4ade80',
    70: '#86efac',
    80: '#bbf7d0',
    90: '#dcfce7',
    100: '#f0fdf4',
  },

  warning: {
    0: '#3d3200',
    10: '#5c4b00',
    20: '#7a6400',
    30: '#997d00',
    40: '#b89600',
    50: '#d4af00',
    60: '#f0c800',
    70: '#ffe033',
    80: '#ffeb66',
    90: '#fff4a3',
    100: '#fffbe6',
  },

  error: {
    0: '#450a0a',
    10: '#7f1d1d',
    20: '#991b1b',
    30: '#b91c1c',
    40: '#dc2626',
    50: '#ef4444',
    60: '#f87171',
    70: '#fca5a5',
    80: '#fecaca',
    90: '#fee2e2',
    100: '#fef2f2',
  },

  info: {
    0: '#0c1a2e',
    10: '#1e3a8a',
    20: '#1e40af',
    30: '#1d4ed8',
    40: '#2563eb',
    50: '#3b82f6',
    60: '#60a5fa',
    70: '#93c5fd',
    80: '#bfdbfe',
    90: '#dbeafe',
    100: '#eff6ff',
  },

  // Paper-specific colors (dark theme - darker papers)
  paper: {
    0: '#2a2a2a',
    10: '#333333',
    20: '#3a3a3a',
    30: '#404040',
    40: '#454545',
    50: '#4a4a4a',
    60: '#505050',
    70: '#555555',
    80: '#5a5a5a',
    90: '#606060',
    100: '#666666',
  },

  // Sidebar-specific colors (dark theme)
  sidebar: {
    0: '#030712',
    10: '#1e293b',
    20: '#334155',
    30: '#475569',
    40: '#4b5563',
    50: '#6b7280',
    60: '#9ca3af',
    70: '#d1d5db',
    80: '#e8e8e8',
    90: '#f5f5f5',
    100: '#ffffff',
  },

  // Tooltip-specific colors (dark theme)
  tooltip: {
    0: '#000000',
    10: '#1f2937',
    20: '#2d2d2d',
    30: '#374151',
    40: '#404040',
    50: '#6b7280',
    60: '#9ca3af',
    70: '#d1d5db',
    80: '#e0e0e0',
    90: '#f5f5f5',
    100: '#ffffff',
  },

  // Note-specific colors (dark theme)
  noteColors: {
    0: '#78350f',
    10: '#1e3a8a',
    20: '#14532d',
    30: '#831843',
    40: '#581c87',
    50: '#9a3412',
    60: '#134e4a',
    70: '#374151',
    80: '#7f1d1d',
    90: '#052e16',
    100: '#0c4a6e',
    110: '#3b0764',
  },
};

export default darkColorPalette;
